import { FIXED } from 'core/constants/products'
import isPlanType from 'utils/pivot/plan/isPlanType'

function isFixedPlan(plan: Plan): boolean {
  return isPlanType(plan, FIXED)
}

export default isFixedPlan
